import React, { Component } from 'react';

const CustomModal = (props) => {
    /*children es una props que nace de la siguiente estructura
    <CustomModal>
    </CustomModal>
    si CustomModal se escribe <CustomModal /> children es undefined
    */
    const { children, mensaje, mostrarModal, titulo } = props;

    return (
        <div className="tarjetas">
            <div className="modal fade in" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
                style={{ display: "flex", paddingRight: "17px" }}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content novedad-info">
                        <div className="modal-header inicial">
                            <div className="row">
                                <div className="col-xs-10">
                                    <h3 className="modal-title">{titulo}</h3>
                                </div>
                                <div className="col-xs-2">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        onClick={() => mostrarModal(false)}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body">
                            {children ?
                                children
                                : <p>{mensaje}</p>}
                        </div>
                        <div className="modal-footer text-right">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal"
                                onClick={() => mostrarModal(false)}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade in"></div>
        </div>
    )
}

export default CustomModal;